import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC5HmCL7JPGbqgd_TH5U-SrkSElP7AyIVI",
  authDomain: "gcjoberp.firebaseapp.com",
  projectId: "gcjoberp",
  storageBucket: "gcjoberp.firebasestorage.app",
  messagingSenderId: "914388231744",
  appId: "1:914388231744:web:c02b266aa1ce19044e21a5",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// ✅ 포그라운드 알림 처리 (앱이 열려있을 때도 팝업 띄우기)
onMessage(messaging, async (payload) => {
  console.log("[FCM] 포그라운드 메시지 수신:", payload);

  // notification 또는 data 필드 둘 다 대응
  const title =
    payload.notification?.title || payload.data?.title || "금천일자리 ERP";
  const body =
    payload.notification?.body || payload.data?.body || "";

  // 서비스워커를 통해 알림 띄우기 (모바일 필수)
  if (Notification.permission === "granted") {
    try {
      const registration = await navigator.serviceWorker.getRegistration(
        "/firebase-messaging-sw.js"
      );
      if (registration) {
        await registration.showNotification(title, {
          body,
          icon: "/logo192.png",
          badge: "/logo192.png",
          tag: payload.data?.taskId || `notif-${Date.now()}`,
          data: payload.data || {},
          vibrate: [200, 100, 200],
          requireInteraction: false,
        });
      } else {
        // 폴백: 서비스워커 없으면 기본 Notification (데스크톱만 동작)
        new Notification(title, { body, icon: "/logo192.png" });
      }
    } catch (e) {
      console.error("[FCM] 알림 표시 실패:", e);
    }
  }
});